import React from 'react'
import { Box, DialogTitle, IconButton } from '@mui/material'
import CloseRoundedIcon from '@mui/icons-material/CloseRounded'

type Props = {
  id?: string
  title: string
  action?: React.ReactNode
  onClose: () => void
}

const DialogHeader = ({ id, title, action, onClose }: Props) => (
  <DialogTitle id={id} aria-label={title}>
    {title}
    <Box
      sx={{
        display: 'flex',
        alignItems: 'center',
        gap: 1,
        flexShrink: 0,
        '& > .MuiButton-root': { height: 32 },
        '& > .MuiIconButton-root': { width: 32, height: 32 },
      }}
    >
      {action}
      <IconButton aria-label="Close" onClick={onClose} size="small" color="inherit">
        <CloseRoundedIcon fontSize="small" sx={{ stroke: 'currentColor', strokeWidth: 0.2 }} />
      </IconButton>
    </Box>
  </DialogTitle>
)

export default DialogHeader
